// extracted by mini-css-extract-plugin
export default {"list":"list--SHaq-","item":"item--SHaq-"};